import React from 'react';
import Layout from '../utils/layout';
import SignUp from '../components/scenes/Auth/scenes/SignUp/SignUp';

export default () => (
  <Layout hideNav>
    <SignUp />
  </Layout>
);
